module.exports = __webpack_public_path__ + "static/media/steve_mccartney.1b889027.jpg";